var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"25%"}},[_c('div',{staticStyle:{"border":"1px solid #ddd","height":"200px"}},[_c('i',{staticClass:"el-icon-video-play"}),_vm._v(" "+_vm._s(_vm.value.Name)+"/"+_vm._s(_vm.value.Parent.Name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }